module.exports = __webpack_public_path__ + "img/11825396_L.a8a38352.png";